import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AppInterceptor } from "./interceptor/app.interceptor";
import { ProgressBarModule } from "./progress-bar/progress-bar.module";
import { SharedDataService } from "./services/dataservice";
import { MaterialModule } from "./shared/material.module";

// import { provideFirebaseApp } from "@angular/fire/app";
//import { getFirestore, provideFirestore } from "@angular/fire/firestore";
// import { initializeApp } from 'firebase/app';
import { AngularFireModule } from '@angular/fire/compat';
import { environment } from 'src/environments/environment';
// initializeApp(environment.firebase);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    MatDialogModule,
    HttpClientModule,
    ProgressBarModule,

    // provideFirebaseApp(() => initializeApp(environment.firebase)),
    // provideFirestore(() => getFirestore())
    AngularFireModule.initializeApp(environment.firebase)
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    SharedDataService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
